import { SOCIAL_PLATFORMS } from '~/constants';

import clientApi from '.';

export const sendAuthReminder = (
  creatorId: string,
  platforms: SOCIAL_PLATFORMS[],
) =>
  clientApi.creators.sendAuthReminder({
    id: creatorId,
    platform: platforms,
  });
